import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';

import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import * as tools from "./tools.jsx";
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";


class TagsList extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
         data_users: [],
         data_tags: [],
      }

      this.interpreter =
      {
         user_id:(id)=>{const user = this.state.data_users.find((u)=>u.user_id == id);return user ? user.name : id}  
      }

      this.clickedEdit = function(tag)
      {
         const self = this;

         var onEditSave = function(editedData)
         {
            if(editedData == null)
            {
               self.props.appCallbacks.popModal();
            }
            else
            {
               var updateDoneCB = function(responseObj)
               {
                  if(responseObj.success)
                  {
                     self.refreshData();
                     self.props.appCallbacks.popModal();
                  }
                  else
                  {
                     self.props.appCallbacks.showResponseErr(responseObj, "Edit Tag Error");
                     
                  }
               };

               self.props.appCallbacks.performAjaxRequest("tags/" + tag.tag_id, "PUT", editedData, updateDoneCB);
            }        
         }

         
         /*const drawFuncObjects = {
            owner:{objects:}
         }*/
         
         const modalProps = {
            saveCallback:onEditSave,
            heading:'Edit Tag',
            data:{name:tag.name},
            
            /*drawFuncObjects:
            {
               user_id:{
                  objects: self.state.data_users.map((u)=>{name:u.name, id:u.user_id}),
                  selectSingle:true
               }
            },
            */
         }

         this.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});

         /*this.props.appCallbacks.setModal(<UpdateDataForm saveCallback={onEditSave}
            heading='Edit Context Data' key={'hans'} data={fieldsToEdit} />);*/
           
      }.bind(this);

      this.clickedDelete = function(tag)
      {
         const self = this;

         const onConfirmDelete = ()=>
         {
            const onServerDelete = (response) => {
               if(response.success)
               {
                  self.refreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Failed deleting tag");
               }
            }
            self.props.appCallbacks.performAjaxRequest('tags/' + tag.tag_id, "DELETE", null, onServerDelete, false);
         }

         const onCancelDelete = ()=>{};

         const deleteMsg = "Delete tag: " + tag.name + " ?\nDeleting this tag will also remove it from all compositions using it. "
         const modalProps = {
            heading: "Confirm Delete",
            msg:deleteMsg,
            onConfirm:onConfirmDelete,
            popModal: self.props.appCallbacks.popModal,
         }
         self.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
      }.bind(this);


      this.extraBtns = [
         {
            name:"edit",
            click: this.clickedEdit
         },
         {
            name:"delete",
            click: this.clickedDelete
         }
      ]
   }

   refreshData()
   {
      this.props.appCallbacks.performAjaxRequest("users", "GET", null,
         tools.getSetBaseDataFunc(this, "data_users").bind(this));

      this.props.appCallbacks.performAjaxRequest("tags", "GET", null,
         tools.getSetBaseDataFunc(this, "data_tags").bind(this));
   }

   componentDidMount()
   {
      this.refreshData();
   }

   clickedAddNewTag()
   {
      const self = this;

      const DrawUserName = (props) => {
         const user = self.state.data_users.find((u)=>u.user_id == props.value);
         const userName = user ? user.name : props.value;
         return (
            <span>
               {userName} (Cannot be edited)
            </span>
         );
      }

      const onNewTagCB = (newTag)=>
      {
         if(newTag)
         {
            const newTagUploaded = (response)=>
            {
               if(response.success)
               {     
                  self.props.appCallbacks.popModal();
                  self.refreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Add Tag");
               }
            }
            this.props.appCallbacks.performAjaxRequest('tags', "POST", newTag, newTagUploaded.bind(this), false);
         }
         else
         {
            self.props.appCallbacks.popModal();
         }
      }
      const emptyTag =
      {
         name:"",
      }
    
      var modalProps = {
            saveCallback:onNewTagCB,
            heading:"Add new Tag",
            data:emptyTag,
         };
    
      this.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});
      
   }




   render() {
      

      var tableStyle1 = {
         background: '#DDDDDD',
         padding: 5 
      }
      
      var tableStyle2 = Object.assign({},tableStyle1);

      tableStyle2.background = '#F0F0F0';

      var divStyle =
      {
         display:'inline'
      }
      return (
         <div style={divStyle}>
            <h1> Tags </h1>
            <InteractiveTable rowObjects={this.state.data_tags} extraBtns={this.extraBtns} interpreter={this.interpreter}/>
            <button onClick={this.clickedAddNewTag.bind(this)}>Add Tag</button>
         </div>
      );
   }
}

export default TagsList ;


// WEBPACK FOOTER //
// ./js/TagsList.jsx